
export const CITY_RANKING_LIST = [{"id":51,"name":"Hồ Chí Minh","score":141058.0,"countryId":243},{"id":2,"name":"Hà Nội","score":74081.0,"countryId":243},{"id":33,"name":"Đà Nẵng","score":11483.0,"countryId":243},{"id":48,"name":"Bình Dương","score":10874.0,"countryId":243},{"id":49,"name":"Đồng Nai","score":6949.0,"countryId":243},{"id":58,"name":"An Giang","score":43.0,"countryId":243},{"id":50,"name":"Bà Rịa Vũng Tàu","score":3928.0,"countryId":243},{"id":16,"name":"Bắc Giang","score":108.0,"countryId":243},{"id":5,"name":"Bắc Kạn","score":2.0,"countryId":243},{"id":63,"name":"Bạc Liêu","score":15.0,"countryId":243},{"id":19,"name":"Bắc Ninh","score":1231.0,"countryId":243},{"id":54,"name":"Bến Tre","score":80.0,"countryId":243},{"id":36,"name":"Bình Định","score":475.0,"countryId":243},{"id":46,"name":"Bình Phước","score":1618.0,"countryId":243},{"id":40,"name":"Bình Thuận","score":1332.0,"countryId":243},{"id":64,"name":"Cà Mau","score":31.0,"countryId":243},{"id":60,"name":"Cần Thơ","score":2358.0,"countryId":243},{"id":4,"name":"Cao Bằng","score":9.0,"countryId":243},{"id":43,"name":"Đắk Lắk","score":311.0,"countryId":243},{"id":44,"name":"Đắk Nông","score":21.0,"countryId":243},{"id":8,"name":"Điện Biên","score":1.0,"countryId":243},{"id":57,"name":"Đồng Tháp","score":70.0,"countryId":243},{"id":42,"name":"Gia Lai","score":64.0,"countryId":243},{"id":3,"name":"Hà Giang","score":2.0,"countryId":243},{"id":24,"name":"Hà Nam","score":130.0,"countryId":243},{"id":29,"name":"Hà Tĩnh","score":75.0,"countryId":243},{"id":20,"name":"Hải Dương","score":169.0,"countryId":243},{"id":21,"name":"Hải Phòng","score":1938.0,"countryId":243},{"id":61,"name":"Hậu Giang","score":148.0,"countryId":243},{"id":12,"name":"Hòa Bình","score":255.0,"countryId":243},{"id":22,"name":"Hưng Yên","score":623.0,"countryId":243},{"id":38,"name":"Khánh Hòa","score":4635.0,"countryId":243},{"id":59,"name":"Kiên Giang","score":1256.0,"countryId":243},{"id":41,"name":"Kon Tum","score":7.0,"countryId":243},{"id":9,"name":"Lai Châu","score":1.0,"countryId":243},{"id":45,"name":"Lâm Đồng","score":1038.0,"countryId":243},{"id":14,"name":"Lạng Sơn","score":43.0,"countryId":243},{"id":7,"name":"Lào Cai","score":91.0,"countryId":243},{"id":52,"name":"Long An","score":5175.0,"countryId":243},{"id":25,"name":"Nam Định","score":31.0,"countryId":243},{"id":28,"name":"Nghệ An","score":208.0,"countryId":243},{"id":26,"name":"Ninh Bình","score":24.0,"countryId":243},{"id":39,"name":"Ninh Thuận","score":43.0,"countryId":243},{"id":17,"name":"Phú Thọ","score":29.0,"countryId":243},{"id":37,"name":"Phú Yên","score":82.0,"countryId":243},{"id":30,"name":"Quảng Bình","score":785.0,"countryId":243},{"id":34,"name":"Quảng Nam","score":2471.0,"countryId":243},{"id":35,"name":"Quảng Ngãi","score":504.0,"countryId":243},{"id":15,"name":"Quảng Ninh","score":1492.0,"countryId":243},{"id":31,"name":"Quảng Trị","score":67.0,"countryId":243},{"id":62,"name":"Sóc Trăng","score":14.0,"countryId":243},{"id":10,"name":"Sơn La","score":6.0,"countryId":243},{"id":47,"name":"Tây Ninh","score":236.0,"countryId":243},{"id":23,"name":"Thái Bình","score":81.0,"countryId":243},{"id":13,"name":"Thái Nguyên","score":359.0,"countryId":243},{"id":27,"name":"Thanh Hóa","score":214.0,"countryId":243},{"id":32,"name":"Thừa Thiên Huế","score":1399.0,"countryId":243},{"id":53,"name":"Tiền Giang","score":116.0,"countryId":243},{"id":55,"name":"Trà Vinh","score":35.0,"countryId":243},{"id":6,"name":"Tuyên Quang","score":6.0,"countryId":243},{"id":56,"name":"Vĩnh Long","score":142.0,"countryId":243},{"id":18,"name":"Vĩnh Phúc","score":480.0,"countryId":243},{"id":11,"name":"Yên Bái","score":21.0,"countryId":243}]
export const DISTRICT_LIST  = []
export const WARD_LIST = []
export const TRANSMISSION_LIST = [{id:1, name: "Tự động"}, {id:2, name: "Số tay"}]
export const YEAR_LIST = [2020, 2019, 2018, 2017, 2015, 2016, 2014, 2013, 2012, 2011, 2010, 2009, 2008]
export const MANUFACTURER_LIST = [ {id:1, name: "Toyota"}, {id:2, name: "Honda"}, {id:3, name: "Hyundai"}, {id:4, name: "Mercedes Benz"} ]

export const NEWS_CATEGORY_LIST = [{"id":1,"name":"Thị trường","parentId":null,"children":[]},{"id":2,"name":"Kiến thức","parentId":null,"children":[]},{"id":3,"name":"Mẫu nhà đẹp","parentId":null,"children":[]},{"id":4,"name":"Phong thuỷ","parentId":null,"children":[]},{"id":5,"name":"Ngôi nhà hạnh phúc","parentId":null,"children":[]},{"id":6,"name":"Ảnh, video hay","parentId":null,"children":[]}]
export const NEWS_LIST = [{"id":6,"title":"Tám câu hỏi quan trọng bạn nhất định phải biết khi mua nhà lần đầu","publishedAt":null,"imageURL":null,"excerpt":"Bạn đã có được khoản tiền lớn để mua căn hộ đầu tiên của chính mình, nhưng chưa có kinh nghiệm. Đừng vội vã, hãy trả lời 8 câu hỏi sau đây để có được lựa chọn đúng đắn nhất cho quyết định quan trọng đầu đời này.","userId":null,"author":null,"commentCount":null,"viewCount":null,"categoryId":2,"categoryName":"Kiến thức"},{"id":5,"title":"Những lỗi khi cải tạo nhà khiến GIA CHỦ sẽ ngã ngửa và khóc ròng","publishedAt":"2019-05-17T04:17:15.767Z","imageURL":null,"excerpt":"Khi sửa nhà hay cải tạo lại nhà, nhiều người vẫn hay mắc các lỗi sau đây","userId":null,"author":null,"commentCount":null,"viewCount":null,"categoryId":2,"categoryName":"Kiến thức"},{"id":4,"title":"Ba xu hướng Marketing Bất động sản 2019","publishedAt":"2019-03-30T15:48:18.031Z","imageURL":"http://cool.zetgoo.com/static/images/re/news/marketing-bat-dong-san-1.jpg","excerpt":"Marketing luôn đòi hỏi người thực hiện phải bắt kịp và đón đầu xu hướng mới, đặc biệt là tiếp thị cho các lĩnh vực đặc thù, mang tính cạnh tranh cao như bất động sản.","userId":null,"author":null,"commentCount":null,"viewCount":null,"categoryId":2,"categoryName":"Kiến thức"},{"id":3,"title":"Cách xác định hệ số K, tính định giá đất","publishedAt":"2019-03-28T22:37:48.873Z","imageURL":null,"excerpt":"Tôi công tác tại Trung tâm Phát triển quỹ đất huyện Vân Đồn, tỉnh Quảng Ninh và đang lập dự toán để thuê tư vấn thực hiện định giá đất đối với khu đất có 20 thửa đất.","userId":null,"author":null,"commentCount":null,"viewCount":null,"categoryId":2,"categoryName":"Kiến thức"},{"id":2,"title":"HoREA kiến nghị đóng phí bảo trì chung cư trong thời hạn 60 tháng","publishedAt":"2019-03-28T22:32:32.498Z","imageURL":null,"excerpt":"Nên quy định chủ sở hữu nhà chung cư phải đóng kinh phí bảo trì 2% này, trong thời hạn 60 tháng, mức đóng hàng tháng được chia đều trong 60 tháng.","userId":null,"author":null,"commentCount":null,"viewCount":null,"categoryId":1,"categoryName":"Thị trường"},{"id":1,"title":"Tám loại giấy tờ người mua nhà cần chuẩn bị trước khi giao dịch bất động sản","publishedAt":"2019-03-28T22:16:56.548Z","imageURL":null,"excerpt":"Bên cạnh nguồn tài chính, người mua nhà cần chuẩn bị nhiều loại giấy tờ như: chứng minh thư, hộ khẩu, giấy xác nhận tình trạng hôn nhân, hợp đồng lao động, bảng lương... để quá trình giao dịch diễn ra suôn sẻ hơn.","userId":null,"author":null,"commentCount":null,"viewCount":null,"categoryId":2,"categoryName":"Kiến thức"}]
export const CLIENT_PREFER_CITIES = [
	{
		id: 1,
		name: 'Hồ Chí Minh',
		count: 134000,
		priceInM2: "93,09 million vnd/m2",
		imageUrl: "/images/hochiminh-1.jpg",
	},
	{
		id: 2,
		name: 'Hà Nội',
		count: 74000,
		priceInM2: "100,09 million vnd/m2",
		imageUrl: "/images/hanoi-1.jpg"
	},
	{
		id: 3,
		name: 'Đà Nẵng',
		count: 24000,
		priceInM2: "13,09 million vnd/m2",
		imageUrl: "/images/danang-1.jpg"
	},
	{
		id: 4,
		name: 'Đồng Nai',
		count: 15000,
		priceInM2: "9,09 million vnd/m2",
		imageUrl: "/images/dongnai-1.jpg"
	}
]
export const PROJECT_LIST = [
	{"id":3195,"name":"Golden Land 5","address":"Phường Lạch Tray, Ngô Quyền, Hải Phòng","imageUrl":"https://file4.batdongsan.com.vn/resize/640x430/2019/04/27/zk7ggeWN/20190427082116-ccec.jpg","investor":"Công ty CP Đầu tư Dịch vụ Tài chính Hoàng Huy","price":null,"area":"9.091 m²","progress":"Đang thi công"},
	{"id":3196,"name":"D-Homme","address":"765 đường Hồng Bàng, Phường 6, Quận 6, Hồ Chí Minh","imageUrl":"https://file4.batdongsan.com.vn/resize/640x430/2019/04/26/zk7ggeWN/20190426161002-8e2f.jpg","investor":null,"price":null,"area":"5.200 m²","progress":"Đang thi công"},
	{"id":3197,"name":"The Metropole Thủ Thiêm","address":"Khu đô thị mới Thủ Thiêm, Quận 2, Hồ Chí Minh","imageUrl":"https://file4.batdongsan.com.vn/resize/640x430/2019/04/25/zk7ggeWN/20190425091105-cd71.jpg","investor":null,"price":null,"area":"76.000 m²","progress":"Đang cập nhật"},
	{"id":3198,"name":"Centennial","address":"Số 2 phố Tôn Đức Thắng, Phường Bến Nghé, Quận 1, Hồ Chí Minh","imageUrl":"https://file4.batdongsan.com.vn/resize/640x430/2019/04/19/zk7ggeWN/20190419151649-f151.jpg","investor":null,"price":null,"area":"3.558 m²","progress":"Đang thi công"},
	{"id":3199,"name":"Lữ Gia Plaza","address":"70 Lữ Gia, Phường 15, Quận 11, Hồ Chí Minh","imageUrl":"https://file1.batdongsan.com.vn/thumb640x430.113618.jpg","investor":"Công ty CP Cơ khí - Điện Lữ Gia","price":null,"area":null,"progress":"Đang cập nhật"},
	{"id":3200,"name":"Chung cư Trường Thành II","address":"36 đường Nguyễn Kiệm, Phường Trường Thi, Vinh, Nghệ An","imageUrl":"https://file4.batdongsan.com.vn/resize/640x430/2019/04/19/zk7ggeWN/20190419140429-1354.jpg","investor":null,"price":null,"area":"3.002 m²","progress":"Đã hoàn thành"},
	{"id":3201,"name":"Chung cư 158 Nguyễn Sơn","address":"158 đường Nguyễn Sơn, Phường Bồ Đề, Long Biên, Hà Nội","imageUrl":"https://file4.batdongsan.com.vn/resize/640x430/2019/04/16/zk7ggeWN/20190416140056-ee5e.jpg","investor":null,"price":null,"area":"8.000 m²","progress":"Đang cập nhật"},
	{"id":3202,"name":"Central Apartment Kinh Dương Vương","address":"Đường Kinh Dương Vương, Phường An Lạc, Bình Tân, Hồ Chí Minh","imageUrl":"https://file4.batdongsan.com.vn/resize/640x430/2019/04/12/zk7ggeWN/20190412095643-7df6.jpg","investor":null,"price":null,"area":"38.291 m²","progress":"Đang thi công"},
	{"id":3203,"name":"Lancaster Luminaire","address":"1152 đường Láng, Phường Láng Thượng, Đống Đa, Hà Nội","imageUrl":"https://file4.batdongsan.com.vn/resize/640x430/2019/04/09/zk7ggeWN/20190409154215-ad86.jpg","investor":"Công ty CP Tân Phú Long","price":null,"area":"6.056 m²","progress":"Đang thi công"},
	{"id":3204,"name":"Khu đô thị Suối Son","address":"X.Giang Điền, H.Trảng Bom, T.Đồng Nai","imageUrl":"https://file4.batdongsan.com.vn/resize/640x430/2017/02/08/Nl3mS01v/20170208154242-6db5.jpg","investor":"Tập đoàn Đất Xanh","price":null,"area":"1.170.900 m²","progress":"Đang cập nhật"}
	]
export const POST_LIST = [
	{
		id: 1,
		title: 'Bán toyota camry 2.5q 2017.id:9351 cũ hồ chí minh',
		address: 'Hồ Chí Minh',
		description: 'Hyundai Solati 16 chổ phiên bản ghế U mới và Hot nhất, chất lượng nhất hiện nay.',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp"
		},
		status: 1
	},
	{
		id: 2,
		title: 'Bán toyota camry 2.5q 2017.id:9351 cũ hồ chí minh',
		address: 'Hồ Chí Minh',
		description: 'Hyundai Solati 16 chổ phiên bản ghế U mới và Hot nhất, chất lượng nhất hiện nay.',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: 'Negotiated',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp"
		},
		status: 1
	},
	{
		id: 3,
		title: 'Bán toyota camry 2.5q 2017.id:9351 cũ hồ chí minh',
		address: 'Hồ Chí Minh',
		description: 'Hyundai Solati 16 chổ phiên bản ghế U mới và Hot nhất, chất lượng nhất hiện nay.',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp"
		},
		status: 1
	},
	{
		id: 4,
		title: 'Bán toyota camry 2.5q 2017.id:9351 cũ hồ chí minh',
		address: 'Hồ Chí Minh',
		description: 'Hyundai Solati 16 chổ phiên bản ghế U mới và Hot nhất, chất lượng nhất hiện nay.',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp"
		},
		status: 1
	},
	{
		id: 5,
		title: 'Bán toyota camry 2.5q 2017.id:9351 cũ hồ chí minh',
		address: 'Hồ Chí Minh',
		description: 'Hyundai Solati 16 chổ phiên bản ghế U mới và Hot nhất, chất lượng nhất hiện nay.',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp"
		},
		status: 1
	}
]
export const NEW_POST_IN_CITY_LIST = [
	{
		id: 1,
		district: 'Quận 3',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		address: '200 Trần Xuân Soạn, Quận 7, HCM',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp",
			rooms: "2",
			area: "54m2",
		},
		status: 1
	},
	{
		id: 2,
		district: 'Quận 5',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		address: 'Đường Quốc Lộ 55, Xã Bình Châu, Xuyên Mộc, Bà Rịa Vũng Tàu',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp",
			rooms: "2",
			area: "54m2",
		},
		status: 1
	},
	{
		id: 3,
		district: 'Quận 1',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		address: 'Hồ Chí Minh',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp",
			rooms: "2",
			area: "54m2",
		},
		status: 1
	},
	{
		id: 4,
		district: 'Quận 7',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		address: '200 Trần Xuân Soạn, Quận 7, HCM',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp",
			rooms: "2",
			area: "54m2",
		},
		status: 1
	},
	{
		id: 5,
		district: 'Bình Tân',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		address: 'Hồ Chí Minh',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp",
			rooms: "2",
			area: "54m2",
		},
		status: 1
	},
	{
		id: 6,
		district: 'Bình thạnh',
		imageURL: 'https://static.carmudi.vn/files/01-2020/ad385731/solati-limited-2020-khuy-n-mai-kh-ng-t-ng-ngay-30-tri-u-giao-ngay-chdhy-t-t-1938380171_large.jpg',
		publishAt: '21/01/2020',
		price: '1 tỷ 45 triệu',
		address: 'Hồ Chí Minh',
		attributes: {
			year: 2019,
			transmission: 'Số tay',
			status: "Mới",
			madein: "Lắp ráp",
			rooms: "2",
			area: "54m2",
		},
		status: 1
	}
]